import {z} from 'zod';
import _keyBy from 'lodash/keyBy';
import {placementSchema} from '../placementsManagementTool.schema';
import validatePlacementData from './validatePlacementData';
import getPlacementKey from './getPlacementKey';
import {CampaignType} from 'common/src/modules/campaigns/campaigns.types';
import {CLEnumsMapper} from 'common/src/modules/enums/enums.types';
import {dspApi} from 'common/src/modules/dsp/dspApi';
import {DSPType} from 'common/src/modules/dsp/dsp.types';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';

interface ValidationResult {
  key: string;
  errors: string[];
}

interface RunPlacementsValidationParams {
  placements: z.infer<typeof placementSchema>[];
  campaignType?: CampaignType;
  campaignEnums?: Record<string, CLEnumsMapper>;
  featureFlags?: Set<FeatureFlagKey>;
}

export default async function runPlacementsValidation({
  placements,
  campaignType,
  campaignEnums,
  featureFlags,
}: RunPlacementsValidationParams): Promise<ValidationResult[]> {
  const dspById = await dspApi
    .getAll({campaignType})
    .then((dspList) => _keyBy<DSPType>(dspList, 'id'));

  const validationResults = placements
    .map((placement) => {
      const result = validatePlacementData({
        placement,
        campaignType,
        campaignEnums,
        availableDSPs: dspById,
        featureFlags,
      });

      if (!result.isValid) {
        return {
          key: getPlacementKey(placement.plcId, placement.dspId),
          errors: result.errors,
        };
      }

      return null;
    })
    .filter(Boolean) as ValidationResult[];

  return validationResults;
}
